var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#emailsenta)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E0E5EE"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#475569",
    clipPath: "url(#emailsentb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.667 7.833c.19.002.38.022.566.06a.077.077 0 0 0 .07 0 .083.083 0 0 0 .03-.066v-2.3a.043.043 0 0 0-.03-.044.053.053 0 0 0-.053 0L7.667 7.287a.723.723 0 0 1-1 0L4.083 5.493a.053.053 0 0 0-.053 0 .047.047 0 0 0-.03.034v3.166a.53.53 0 0 0 .527.53h2.666a.08.08 0 0 0 .07-.04 2.83 2.83 0 0 1 2.404-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.935 7a.333.333 0 0 0 .467 0l2.556-1.77a.137.137 0 0 0 .044-.137.127.127 0 0 0-.12-.093h-5.43a.127.127 0 0 0-.117.093.137.137 0 0 0 .03.137L6.935 7ZM9.665 8.333a2.333 2.333 0 1 0 0 4.667 2.333 2.333 0 0 0 0-4.667Zm0 4a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.116 10.017-.697.926-.3-.3a.333.333 0 1 0-.47.474l.407.403a.53.53 0 0 0 .807-.057l.803-1.046a.335.335 0 1 0-.537-.4h-.013Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "emailsenta"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "emailsentb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 5h8v8H4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.088c49d54b5161f46720bfdc0804f892.svg";
export { ForwardRef as ReactComponent };